import React from "react";
import { getAssets } from "@unisearch/helpers";
import {
  LeadSectionHero,
  LeadSectionFeatures,
  LeadSectionForm,
} from "../components";
import styles from "./template.module.scss";

export const LeadTemplateWebinar = ({ pageData }) => {
  return (
    <>
      <LeadSectionHero pageData={pageData}/>
      <div className={styles.description_and_form_section_wrapper}>
        <LeadSectionFeatures pageData={pageData}/>
        <LeadSectionForm pageData={pageData}/>
      </div>
    </>
  );
};

export default LeadTemplateWebinar;
